// src/services/api/vendor.js
import apiClient from "../../utils/apiClient";
const APIKEY = process.env.REACT_APP_INTERNAL_API_KEY


export const NearByVendors = (params) => {
  return apiClient.get(`/products/products/nearby-vendors`, {
    headers: {
      "x-api-key": APIKEY
    },
    params: {
      postalCode: params.postalCode,
      page: params.page,
      limit: params.limit,
    },
  });
};

export const getVendorCategories = (vendorId) => {
  return apiClient.get(`/products/categories/vendor`, {
    headers: {
      "x-api-key": APIKEY
    },
    params: {
      vendorId: vendorId,
    },
  });
};

export const getVendorProducts = (params) => {
  return apiClient.get(`/products/products`, {
    headers: {
      "x-api-key": APIKEY
    },
    params: {
      vendorId: params.vendorId,
      categoryId: params.categoryId,
      page: params.page,
      limit: params.limit,
      postalCode: params.postalCode,
      isActive: params.isActive,
    },
  });
};
